export const PAID_COLUMN_HEADINGS = [
	'customFields-responses-table-orderId',
	'customFields-responses-table-type',
	'customFields-responses-table-email',
	'customFields-responses-table-fullName',
	'customFields-responses-table-phone',
	'customFields-responses-table-amount',
	'customFields-responses-table-date',
	'customFields-responses-table-status',
	'customFields-responses-table-ticketTypes',
	'customFields-responses-table-scanned',
	'customFields-responses-table-promotion',
	'customFields-responses-table-giftCards',
	'customFields-responses-table-seat',
];

export const REGISTRATION_COLUMN_HEADINGS = [
	'customFields-responses-table-orderId',
	'customFields-responses-table-type',
	'customFields-responses-table-email',
	'customFields-responses-table-fullName',
	'customFields-responses-table-phone',
	'customFields-responses-table-date',
	'customFields-responses-table-ticketTypes',
	'customFields-responses-table-scanned',
	'customFields-responses-table-promotion',
	'customFields-responses-table-giftCards',
	'customFields-responses-table-seat',
];

// Index map (positional — body + getCellIndex depend on it):
// 0 orderId, 1 type, 2 email, 3 fullName, 4 phone, 5 amount, 6 date, 7 status,
// 8 ticketTypes, 9 scanned, 10 promotion, 11 giftCards, 12 seat.
export const COLUMN_MIN_WIDTH = [100, 150, 300, 250, 160, 250, 120, 250, 120, 250, 120, 180, 180, 180, 50];
export const COLUMN_MAX_WIDTH = [
	undefined,
	undefined,
	undefined,
	undefined,
	undefined,
	450,
	undefined,
	undefined,
	undefined,
	undefined,
	150,
	200,
	200,
	250,
	undefined,
];

export const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const RESPONSES_INDEX = 5;

export const RESEND_EMAIL_COLUMN_MIN_WIDTH = 120;
export const RESEND_EMAIL_COLUMN_MAX_WIDTH = 150;
